import React from 'react';

const AMBER = '#E09B1A';

function driStatusBand(score) {
  if (score == null || Number.isNaN(Number(score))) {
    return { label: '—', pillBg: 'rgba(107, 114, 128, 0.15)', pillColor: '#6b7280' };
  }
  const n = Number(score);
  if (n >= 80) {
    return { label: 'Compliance Verified', pillBg: 'rgba(63, 185, 80, 0.2)', pillColor: '#3fb950' };
  }
  if (n >= 60) {
    return { label: 'Needs Attention', pillBg: 'rgba(224, 155, 26, 0.2)', pillColor: '#E09B1A' };
  }
  return { label: 'Needs Setup', pillBg: 'rgba(248, 81, 73, 0.2)', pillColor: '#f85149' };
}

export default function AnalyticsDriIntelligenceHeader({ driScore, loading }) {
  const band = driStatusBand(driScore);
  const showScore = !loading && driScore != null && !Number.isNaN(Number(driScore));

  return (
    <section className="analytics-dri-intelligence-header" aria-label="Compliance intelligence and DRI Score">
      <div className="analytics-dri-intelligence-header__left">
        <p className="analytics-dri-intelligence-header__eyebrow">COMPLIANCE INTELLIGENCE</p>
        <h2 className="analytics-dri-intelligence-header__title">These metrics power your DRI Score™</h2>
        <p className="analytics-dri-intelligence-header__subtitle">
          Every snapshot Sovrynn takes builds your compliance history. The longer you use Sovrynn, the more powerful your
          intelligence becomes.
        </p>
      </div>
      <div className="analytics-dri-intelligence-header__right">
        {loading ? (
          <div className="analytics-dri-intelligence-header__score-loading" aria-hidden>
            <div className="loading-spinner" />
          </div>
        ) : (
          <>
            <span className="analytics-dri-intelligence-header__score-value" style={{ color: AMBER }}>
              {showScore ? Math.round(Number(driScore)) : '—'}
            </span>
            <span className="analytics-dri-intelligence-header__score-label">Current DRI Score™</span>
            <span
              className="analytics-dri-intelligence-header__status-badge"
              style={{ backgroundColor: band.pillBg, color: band.pillColor }}
            >
              {band.label}
            </span>
          </>
        )}
      </div>
    </section>
  );
}
